// src/Services.js
import React, { useCallback } from 'react';
import TopBar from '../components/TopBar';
import layoutStyles from '../styles/layout.module.css';
import { useNavigate } from 'react-router-dom';

export default function Services() {
  const navigate = useNavigate();
  const handleBack = useCallback(() => {
    if (window.history.length > 2) navigate(-1); else navigate('/home');
  }, [navigate]);
  return (
    <div className={layoutStyles.detailPage}>
      <TopBar variant="back" backLabel="Back" onBack={handleBack} rightActionLabel="Home" onRightAction={() => navigate('/home')} />
      <div style={{ maxWidth: 720, width: '100%', margin: '80px auto', padding: '0 16px' }}>
        <h1>Services</h1>
        <p style={{ color: '#475569' }}>
          Razzberry provides a marketplace for music artists to publish digital collectibles for verified fans and collectors.
        </p>

        <h2>For Artists</h2>
        <p style={{ color: '#475569' }}>
          Publish artist profiles, launch collectibles, and manage audience engagement. Artist access uses a subscription, and
          Stripe Express payout setup can finish after launch while creator proceeds remain held until release.
        </p>

        <h2>For Collectors</h2>
        <p style={{ color: '#475569' }}>
          Browse verified artists, buy available products securely, and track payments in your account. Availability and pricing
          are set by artists.
        </p>

        <h2>Payments and Verification</h2>
        <p style={{ color: '#475569' }}>
          Payments are handled by Stripe. Razzberry uses verification workflows to reduce fraud, but we cannot guarantee
          the authenticity of all products or participants.
        </p>

        <h2>Support</h2>
        <p style={{ color: '#475569' }}>
          For account support and billing issues, contact the Razzberry team or Stripe support where applicable.
        </p>
      </div>
    </div>
  );
}
